export const COLORS = {
  red: "#FF4757",
  blue: "#3EAEFF",
  green: "#2ED573",
  orange: "#FFA502",
  purple: "#A855F7",
  coral: "#FF6B81",
};

export const COLOR_LIST = [
  "#FF4757","#3EAEFF","#2ED573","#FFA502","#A855F7","#FF6B81",
  "#FFA502","#2ED573","#FF4757","#3EAEFF","#FF6B81","#A855F7",
  "#2ED573","#A855F7","#FFA502","#FF4757","#3EAEFF","#2ED573",
  "#FF6B81","#FF4757","#3EAEFF","#A855F7","#FFA502","#FF4757",
  "#3EAEFF","#2ED573","#FF6B81","#FFA502","#FF4757","#A855F7",
  "#FFA502","#FF6B81","#A855F7","#2ED573","#3EAEFF","#FF4757",
];